// JavaScript
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "list"]
    static values = {
        url: String,
        min: { type: Number, default: 2 },
        delay: { type: Number, default: 200 }
    }

    connect() {
        this._aborter = null
        this._timer = null
    }

    // Triggered on input: data-action="input->simple-filter#fetch"
    fetch() {
        // Debounce keystrokes
        clearTimeout(this._timer)
        this._timer = setTimeout(() => this._doFetch(), this.delayValue)
    }

    async _doFetch() {
        const raw = this.hasInputTarget ? this.inputTarget.value || "" : ""
        const q = raw.trim()
        if (!q || q.length < this.minValue) {
            this._render([])
            return
        }

        // Abort in-flight request
        if (this._aborter) this._aborter.abort()
        this._aborter = new AbortController()

        try {
            const url = new URL(this.urlValue, window.location.origin)
            url.searchParams.set("q", raw)
            url.searchParams.set("limit", "20")

            const res = await fetch(url.toString(), {
                headers: { Accept: "application/json" },
                signal: this._aborter.signal
            })
            if (!res.ok) throw new Error(`HTTP ${res.status}`)

            const items = await res.json() // [{id, name}]
            this._render(items)
        } catch (e) {
            if (e.name !== "AbortError") {
                // Optional: show an error state
                this._render([])
            }
        }
    }

    select(event) {
        const li = event.currentTarget
        if (!li) return
        const label = li.getAttribute("data-text") || li.textContent || ""
        if (this.hasInputTarget) {
            this.inputTarget.value = label
            this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
        }
    }

    _render(items) {
        if (!this.hasListTarget) return
        if (!items || items.length === 0) {
            this.listTarget.innerHTML = `<li class="px-3 py-2 text-gray-500">No matches.</li>`
            return
        }
        const esc = s =>
            String(s ?? "")
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#39;")

        const html = items
            .map(
                (it) => `
          <li data-item
              data-id="${esc(it.id)}"
              data-text="${esc(it.name)}"
              class="cursor-pointer px-3 py-2 hover:bg-gray-100"
              data-action="click->simple-filter#select">
            ${esc(it.name)}
          </li>`
            )
            .join("")
        this.listTarget.innerHTML = html
    }
}